<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
        <div style="margin:0 auto; text-align: center;"><el-image src="/pc/miaosha_banner.png"></el-image></div>
        <!-- <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="goods/seckill">限时秒杀</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->

        <div class="goods_where width_center_1200">
            <ul>
                <li v-for="(v,k) in seckill_list" :key="k" @click="change_seckill(v.id)" :class="v.id==seckill_info['id']?'red':''">{{v.name}} <span v-if="v.id==seckill_info['id']">距离{{fontSkill}} {{hour}}:{{min}}:{{secs}}</span><font v-else>{{v.is_active?'活动中':'即将开始'}}</font></li>

<li  @click="change_seckill(1)" :class="1==id?'red':''">10:00 场  <span>距离开始 {{hour}}:{{min}}:{{secs}}</span></li>
<li  @click="change_seckill(2)" :class="2==id?'red':''">14:00 场  <span>距离结束 {{hour}}:{{min}}:{{secs}}</span></li>
<li  @click="change_seckill(3)" :class="3==id?'red':''">16:00 场  <span>已结束 </span></li>

            </ul>
        </div>

        <div class="goods_list width_center_1200"  v-if="goods_list">

           
            <div class="goods_list_item" v-for="(v,k) in goods_list" :key="k">

                <dl v-if="v.selltype != 3">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <dt><img v-if="filePath" :src="filePath + v.img" :alt="v.name" :title="v.name"></dt>
                <dd class="p-icons">
                 <i v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                </dd>
                <dd class="title" :title="v.name">{{v.name}}</dd>
                <dd class="ftitle" :title="v.name">{{v.company_name}}</dd>
                <dd class="parameter">规格:{{v.spec}}</dd>
                <dd class="parameter">效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.stock > 200">库存:充足</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                     </router-link>

                    <dd  class="item-operate">
                    <!-- <div class="num-operate">
                        <span class="num-subtract" @click="change_buy_num(v,false)">-</span>
                        <input v-model="v.max" v-enter-number type="text" @on-change="changenum(v)" class="j_num" @change="changenum(v)">
                        <span class="num-add" @click="change_buy_num(v,true)">+</span>
                    </div> -->
                    <div @click="add_cart(v)" class="j_addCart addcart" style="width:100%; border-left:1px solid #ddd">立即抢购</div>
                    </dd>
                    <!-- <dd><span class="buy">立即购买</span><span class="evaluate">{{v.comment_count}} 人评价</span></dd> -->
                </dl>
            </div>
            
        </div>

        <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>暂无商品！
        </div>

        <div class="home_fy_block  width_center_1200" v-if="goods_list">
            <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
        </div>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar
    },
    data() {
      return {
          goods_list:[],
          seckill_list:[],
          seckill_info:{},
          total_data:0, // 总条数
          page_size:30,
          current_page:1,
          id:1,
          hour:0,
          min:0,
          secs:0,
          intvalobj:null,
          fontSkill:'开始',
      };
    },
    watch: {
        info:{
            handler(){
                this.search_goods();
            },
            deep:true,
        }
    },
    computed: {},
    methods: {
        current_change:function(e){
            this.current_page = e;
            this.get_seckill_list();
        },
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },
        get_seckill_list:function(){
            // this.$get(this.$api.queryGoodsAll,
            // // {pageNum:this.current_page,id:this.id}
            // ).then(res=>{
                this.$get(this.$api.getSpecialGoodsById,{subjectId:'MjAyMDEwMTNfMTc='}).then(res=>{
                this.goods_list = res.data.list[0].indexGoodsParamList;
                this.total_data = res.data.list[0].count;
                // this.seckill_list = res.data.list;
                // this.seckill_info = res.data.seckill_info;
                // this.start_time();
            });
        },
        change_seckill:function(id){
            alert(id);
            this.id = id;
            this.get_seckill_list();
        },
        start_time:function(){
            if(this.intvalobj != null){
                clearInterval(this.intvalobj);
            }
            this.intvalobj = setInterval(()=>{
                let start_time = this.seckill_info.start_time;
                let end_time = this.seckill_info.end_time;
                let timestamp = Date.parse(new Date())/1000;
                if(start_time>timestamp){
                    let sec = start_time-timestamp;
                    this.hour = Math.floor(sec/3600);
                    this.min = Math.floor((sec-(this.hour*3600))/60);
                    this.secs = sec-(this.hour*60+this.min)*60;
                    this.fontSkill = '开始';
                }else if(end_time>timestamp){
                    let sec2 = end_time-timestamp;
                    this.hour = Math.floor(sec2/3600);
                    this.min = Math.floor((sec2-(this.hour*3600))/60);
                    this.secs = sec2-(this.hour*60+this.min)*60;
                    this.fontSkill = '结束';
                }else{
                    this.hour = 0;
                    this.min = 0;
                    this.secs = 0;
                    clearInterval(this.intvalobj);
                }
            },1000);
        },

        add_cart:function(e){
            if(e.mini_qty == null){
                return this.$message.error('购买数量不正确');
            }else if(e.mini_qty <= e.stock ){
            this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.mini_qty,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}]}).then(res=>{
                if(res.code == 200){
                    if(res.data=='加入购物车成功'){
                        this.get_seckill_list();
                        this.cart_change += 1; // 修改购物车数据
                        return this.$message.success('加入购物车成功');
                    }
                    else{
                        return this.$message.error(res.data);
                    }
                }else if(res.code == 500){
                    if(res.message=='请登录'){
                        this.$message.error('请先登录！');
                        return this.$router.push('/user/login');
                    }else{
                        return this.$message.error('加入购物车失败'); 
                    }
                }else{
                    return this.$message.error(res.message);
                }
            });  
            }else{
                return this.$message.error('库存不足');
                //this.diasabledInput = true
            }
        }
        
    },
    created() {
        this.filepath();
        this.get_seckill_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_sort_top{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.mbx{
    margin:20px auto;
}
.goods_where{
    background: #eee;
    ul li{
        float: left;
        line-height: 50px;
        text-align: center;
        width: 400px;
        font-size: 20px;
        font-weight: bold;
        span{
            font-size: 14px;
            margin-left: 15px;
            font-weight: normal;
        }
        font{
            border: 1px solid #666;
            border-radius: 6px;
            line-height: 35px;
            font-size: 14px;
            padding: 3px 6px;
            margin-left: 15px;
        }
    }
    ul li.red{
        background: #409EFF;
        color:#fff;
    }
}
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 445px;
        box-sizing: border-box;
        margin: 0 20px 20px 0;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 445px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 20px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:20px auto 20px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 194px;
        }
        dl .parameter{
            font-size: 14px;
            color:#666666;
            line-height: 22px;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #F56C6C;
        // }
        dl dd span{
            width: 50%;
            display: block;
            // border-top: 1px solid #efefef;
            float: left;
            line-height: 20px;
            text-align: left;
        }
    }
    .goods_list_item:nth-child(5n){
        margin-right: 0;
    }
    // .goods_list_item:hover{
    //     // border:1px solid #F56C6C;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
.goods_list_item a:hover .title{
	color:#409EFF;
}
}
</style>